Button = require 'components/common/button'
CustomRenderMixin = require 'components/mixins/custom_render_mixin'
EtdEditor = require 'components/etd/etd_editor'
{ RICH_FORMAT_FIELDS } = require 'lib/etd_header_helper'
Translation = require 'components/mixins/translation'

EtdHeaderEditableCell = createReactClass
  displayName: 'EtdHeaderEditableCell'

  propTypes:
    questionType: PropTypes.string
    updateHeaderFieldContent: PropTypes.func

  mixins: [CustomRenderMixin, Translation('es:question')]

  _inputElRef: (el) ->
    @gdtEditor = el

  focus: ->
    @gdtEditor?.focus()

  saveContent: ->
    if @gdtEditor?.saveContent?
      @gdtEditor.saveContent @updateContent
    else
      @updateContent()

  renderInputElement: ->
    { sectionId, content, contentComponent, inAutoMode } = @props

    if sectionId in ['intervention', 'comparison']
      <input ref={@_inputElRef} type="text" value={content} disabled />
    else if contentComponent? and inAutoMode
      contentComponent
    else if sectionId in RICH_FORMAT_FIELDS
      <EtdEditor
        cellId="etdHeaderEditableCell"
        content={content ? ''}
        editable={not inAutoMode}
        minimal={inAutoMode}
        noInsertOption={sectionId isnt 'background'}
        onBlur={@updateContent}
        onSaveContent={@updateContent}
        questionType={@props.questionType}
        readOnly={inAutoMode}
        ref={@_inputElRef}
        renderMode="regular"
        withApplyCancelButtons={false}
      />
    else if inAutoMode
      <span className='textarea-content'>{content}</span>
    else
      <textarea
        ref={@_inputElRef}
        defaultValue={content}
        onBlur={@updateContent}
      />

  updateContent: (data = {}) ->
    { content } = data
    content ?= @gdtEditor?.value
    if @props.content isnt content
      @props.updateHeaderFieldContent { content, sectionId: @props.sectionId }

  render: ->
    withSwitchButton = @props.sectionId in ['population', 'mainOutcomes', 'setting']
    switchButtonLabel = if @props.inAutoMode then 'switch_to_manual' else 'switch_to_auto'
    editableClassNames = classNames 'edit-container',
      'with-switch': withSwitchButton
      'in-auto-mode': @props.inAutoMode
      'rows-1': @props.sectionId in ['purpose', 'linkedTreatments']
      'rows-2': @props.sectionId in ['setting', 'perspective', 'subgroups']
      'rows-4': @props.sectionId in ['anticipatedOutcomes', 'mainOutcomes', 'background', 'coi']

    if @props.isEditing
      <td rowSpan={@props.rowSpan}>
        <div className={editableClassNames}>
          {@renderInputElement()}
        </div>
        {if withSwitchButton
          <Button
            className="btn auto-manual-switch "
            label={@i18n switchButtonLabel}
            onClick={@props.showContentModeSwitchModal}
          />
        }
      </td>
    else
      <td className="editable-cell" rowSpan={@props.rowSpan}>
        {if @props.contentComponent? and @props.inAutoMode
          @props.contentComponent
        else if @props.sectionId in RICH_FORMAT_FIELDS
          <EtdEditor
            cellId="etdHeaderEditableCell"
            content={@props.content ? ''}
            editable={false}
            minimal
            readOnly
            renderMode="regular"
          />
        else
          <p dangerouslySetInnerHTML={{__html: @props.content}} />
        }
      </td>

module.exports = EtdHeaderEditableCell
